import React from 'react';
import PropTypes from "prop-types";

export default function PaymentsSVG(props) {
  return (
    <svg
      version="1.1"
      id={props.id || ''}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 60 38"
      fill={props.styles.fill}
      height={props.styles.height}
      width={props.styles.width}
      className={props.className || ''}
    >
      <path
        className="st0"
        d="M59,0H1C0.4,0,0,0.4,0,1v30c0,0.5,0.4,1,1,1h58c0.5,0,1-0.5,1-1V1C60,0.4,59.5,0,59,0z M58,30H2V2h56V30z"
      />
      <path
        className="st0"
        d="M4,22c3.3,0,6,2.7,6,6c0,0.5,0.4,1,1,1h38c0.5,0,1-0.5,1-1c0-3.3,2.7-6,6-6c0.5,0,1-0.5,1-1V11c0-0.6-0.5-1-1-1
          c-3.3,0-6-2.7-6-6c0-0.5-0.5-1-1-1H11c-0.6,0-1,0.5-1,1c0,3.3-2.7,6-6,6c-0.5,0-1,0.4-1,1v10C3,21.5,3.5,22,4,22z M5,11.9
          c3.6-0.4,6.5-3.3,6.9-6.9h36.1c0.5,3.6,3.3,6.5,6.9,6.9v8.1c-3.6,0.5-6.5,3.3-6.9,6.9H11.9c-0.4-3.6-3.3-6.5-6.9-6.9
          C5,20.1,5,11.9,5,11.9z"
      />
      <path
        className="st0"
        d="M30,25c5,0,9-4,9-9s-4-9-9-9s-9,4-9,9S25,25,30,25z M30,9c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S26.1,9,30,9z"
      />
      <rect x="41" y="15" className="st0" width="4" height="2" />
      <rect x="15" y="15" className="st0" width="4" height="2" />
      <rect x="1" y="33" className="st0" width="58" height="2" />
      <rect x="1" y="36" className="st0" width="58" height="2" />
    </svg>
  );
}

PaymentsSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
